export const LOWEST_PRICE_BANNER_TEXT =
  "We selected the flights with the current lowest price for you. You can also";
export const LOWEST_PRICE_BANNER_BUTTON_TEXT = "select a different flight";
export const PERIOD_TEXT = ".";
export const SHOW_FLIGHT_DETAILS_TEXT = "Show flight details";
export const VIEW_DETAILS_TEXT = "View details";
export const CHANGE_TEXT = "Change";
export const CHANGE_FLIGHT_TEXT = "Change flight";
